module.exports = __webpack_public_path__ + "img/urbi-06.c6c70040.jpg";